<template>
	<div>
		<div class="md-layout">
			<entity-card
				v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" @openUpload="showModal = true" :entity.sync="entity">
			</entity-card>
		</div>
	</div>
</template>

<script>
	import Video from "@/models/video.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import ImportModal from "@/components/Espresso/ImportModal.vue"

	export default {
		components: {
			EntityCard,
			ImportModal,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Video.getSchema(),
				name: "Enviar video",
				showModal: false,
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Video.create(entity);
				this.$router.replace(`/videos/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Video.getInfo(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Video.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Video.remove(entityId);
				this.$router.push("/videos");
			},
		},
	};
</script>
